import React, { useEffect } from "react";
import FulfilmentCard from "./cards/FulfilmentCard";
import { Heading } from "@reliance/design-system";
import DeliveryDislaimer from "./DeliveryDislaimer";
import { eventName } from "../services/constants";

import { logAnalyticsEvent } from "../firebaseInit";
import { useTranslation } from "react-i18next";
const FulfilmentOptions = ({
  onProceedRecommendedPickup,
  onProceedDelivery,
  onProceedPickup,
  handleRFCLocations,
  showRfc,
  hasDelivery,
  contactDetails,
  ...props
}) => {
  const { prescriptionId } = props;
  const { t } = useTranslation(["consultations"]);

  logAnalyticsEvent(eventName.VIEW_PRESCRIPTION_FULFILLMENT_OPTIONS, {
    states: contactDetails?.state,
    item_name: prescriptionId,
  });
  return (
    <div>
      <Heading level={"h4"}>{t("prescriptionFulfilmentOptionHeading")}</Heading>
      <div style={{ fontSize: 16, marginBottom: 12, marginTop: 10 }}>
        {t("prescriptionFulfilmentOptionSubHeading")}
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: 24 }}>
        {showRfc && (
          <FulfilmentCard
            options={[
              handleRFCLocations() &&
                `${t("locatedIn")} ${handleRFCLocations()}`,
              t("medicationAvailabilityRfcFulfilmentCardOption"),
              t("pickupWithin2HoursRfcFulfilmentCardOption"),
              t("ministryOfHealthTestedMedicationRfcFulfilmentCardOption"),
              t("pharmacistExpertiseRfcFulfilmentCardOption"),
            ].filter(Boolean)} // Filters out any empty strings
            onClick={onProceedRecommendedPickup}
            recommended={true}
            deliveryType="pickup"
          />
        )}
        <FulfilmentCard
          options={[
            t("multipleLocationsFulfilmentCardOption"),
            t("pickupWithin3HoursFulfilmentCardOption"),
          ]}
          onClick={onProceedPickup}
          recommended={false}
          deliveryType={"pickup"}
        />

        {hasDelivery && (
          <FulfilmentCard
            options={[t("medicationDeliveryWithin4HoursFulfilmentCardOption")]}
            recommended={false}
            deliveryType={"delivery"}
            onClick={onProceedDelivery}
          >
            <DeliveryDislaimer />
          </FulfilmentCard>
        )}
      </div>
    </div>
  );
};

export default FulfilmentOptions;
